module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Bold.84929c7.woff";